export default function () {
  return {
    name: null,
    short_name: null,
    structure: [],
  }
}